import React, { useEffect, useState } from "react";

import {PageHeader, Tag} from "antd";
import { withRouter } from 'react-router-dom';
import "./CustomRxPageHeader.scss";

import { connect } from "react-redux";

import { displayNumberWithComma } from 'utils/utils';
import {FormattedMessage} from "react-intl";
import {callGetMasterBalance} from "../rx/dashboard/dashboardAction";

import config from "../config";

function CustomRxPageHeader(props) {
    useEffect(() => {
        props.callGetMasterBalance();
    }, []);
    
    let balanceTitle = "";
    let hasBalance = false;
    let hasSgdBalance = false;
    let hasHkdBalance = false;
    let hasUsdBalance = false;
    
    let i = 0;
    let balance = [];

    var masterBalance = props.masterBalance;
    for (let key in masterBalance) {
        hasBalance = true;
        if (key==='USD') {
            hasUsdBalance = true;
        } else if (key==='HKD') {
            hasHkdBalance = true;
        } else if (key==='SGD') {
            hasSgdBalance = true;
        }
        if(masterBalance[key]==0 || masterBalance[key]==''){
            balanceTitle += key + " 0.00";
            balance.push(key + " 0.00");
        }else{
            balanceTitle += key + " " + displayNumberWithComma(masterBalance[key]);
            balance.push(key + " " + displayNumberWithComma(masterBalance[key]));
        }

        i++;
        if (i < Object.keys(masterBalance).length) {
            balanceTitle += ",   ";
        }
    }

    if (props.customer.companyProfile.baseCurrency === 'SGD') {
        if (!hasSgdBalance) {
            balance.push('SGD 0.00');
        } else if (!hasUsdBalance) {
            balance.push('USD 0.00');
        }
    } else if (props.customer.companyProfile.baseCurrency === 'HKD') {
        if (!hasHkdBalance) {
            balance.push('HKD 0.00');
        } else if (!hasUsdBalance) {
            balance.push('USD 0.00');
        }
    }

    return (
        <><PageHeader className="bp-page-header" title={props.title} tags={buildMasterBalanceTags(balance)} /></>
    );
}

const buildMasterBalanceTags = (balance) => {
    let result =[];
    result.push(<span key='master-balance' className='master-balance'><FormattedMessage id="app.header.masterbalance"/></span>);

    if(balance.length >0) {
        balance.map((value, idx) => {
            result.push(<Tag key={idx} style={{padding: '4px', fontSize: '1em'}} color="blue">{`${value}`}</Tag>);
        });
    }
    return (<>{result}</>);
}

const mapStateToProps = (state) => {
    return {
      masterBalance: state.dashboard.masterBalance,  
    };
};
  
const mapDispatchToProps = (dispatch) => {
    return {
        callGetMasterBalance: () => dispatch(callGetMasterBalance()),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(CustomRxPageHeader));